import React, { useState } from "react";

import "../css/LynxStyle.css";

const DaysAliveCounter = () => {
  const [birthdate, setBirthdate] = useState("");
  const [result, setResult] = useState(null);

  const CalculateDaysAlive = () => {
    if (!birthdate) {
      return;
    }
    const start = new Date(birthdate);
    const now = new Date();
    const msPerDay = 1000 * 60 * 60 * 24;
    const totalDays = Math.max(
      0,
      Math.floor((now.getTime() - start.getTime()) / msPerDay)
    );
    const years = Math.floor(totalDays / 365.25);
    const weeks = Math.floor(totalDays / 7);

    setResult({ totalDays, years, weeks });
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">🎂 Days Alive Counter</h3>
      <div className="lynx-page-card">
        <form>
          <div className="form-group">
            <label htmlFor="birthdate" className="text-white">
              Your Birthdate:
            </label>
            <input
              type="date"
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
              className="form-control"
              id="birthdate"
            />
          </div>
          <div className="text-center mt-3">
            <button
              type="button"
              onClick={CalculateDaysAlive}
              className="btn-lynx w-100"
            >
              🎉 Calculate
            </button>
          </div>
        </form>
        {result && (
          <div className="smsgpt text-center mt-3 fs-5">
            You've been alive for {result.totalDays.toLocaleString()} days!
            <br />
            <small>
              That's about {result.weeks.toLocaleString()} weeks, or{" "}
              {result.years} years 🎈
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

export default DaysAliveCounter;
